import React, { useState, useEffect } from "react";
import {Autocomplete,TextField,Button,Table,TableHead,TableRow,TableContainer,TableCell,TableBody,Container,Paper,Box,} from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";


import { saveAs } from "file-saver";
import { BASE_URL } from "../../App";

 const BRANCH_CODE = "1702";
// const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

const MechanicReport = () => {
  const [schemes, setSchemes] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [mechanicData, setMechanicData] = useState([]);

  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        Swal.fire({
          title: "Loading...",
          text: "Fetching schemes...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const res = await axios.post(`${BASE_URL}/getSchemes`);
        Swal.close();

        if (res.data && res.data.length > 0) {
          setSchemes(
            res.data.map((item) => ({
              label: item.scheme_id || "Unknown",
              value: item.scheme_id,
            }))
          );
        } else {
          Swal.fire("Info", "No schemes found", "info");
        }
      } catch (error) {
        Swal.close();
        console.error("Error fetching schemes:", error);
        Swal.fire("Error", "Failed to load schemes", "error");
      }
    };

    fetchSchemes();
  }, []);

  const handleSubmit = async () => {
    if (!selectedScheme) {
      Swal.fire("Warning", "Please select a scheme", "warning");
      return;
    }

    try {
      Swal.fire({
        title: "Loading...",
        text: "Fetching mechanic data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await axios.post(`${BASE_URL}/getMechanics`, {
        scheme_id: selectedScheme.value,
        branchcode: BRANCH_CODE,
      });

      Swal.close();
      setMechanicData(res.data);
      // Swal.fire("Success", "Mechanic data loaded successfully", "success");
    } catch (error) {
      Swal.close();
      console.error("Error fetching mechanic data:", error);
      Swal.fire("Error", "Failed to fetch mechanic data", "error");
    }
  };

  const navigate = useNavigate();

const handleRedirectToExport = () => {
  navigate("/home/Reports/Mechanic_Report_Excel_Download");
};

  
 

  const handleDownloadTable = async () => {
    if (mechanicData.length === 0) {
      Swal.fire("Info", "No mechanic data to download", "info");
      return;
    }
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to download this table as Excel?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, download it!",
    });
  
    if (result.isConfirmed) {
      Swal.fire({
        title: "Preparing download...",
        text: "Generating Excel file...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      try {
        const ws = XLSX.utils.json_to_sheet(mechanicData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Mechanics");
  
        const excelBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array",
        });
  
        const blob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
  
        saveAs(blob, `MechanicReport_${selectedScheme?.label || "Data"}.xlsx`);
  
        Swal.close();
  
        setTimeout(() => {
          Swal.fire("Success", "Excel downloaded successfully", "success");
        }, 200);
      } catch (err) {
        Swal.close();
        console.error("Excel export error:", err);
        Swal.fire("Error", "Failed to export Excel", "error");
      }
    }
  };
  

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
        {/* <h2>Mechanic Report</h2> */}
        <Box>
          <Button
            variant="contained"
            color="success"
            sx={{ marginTop: 2 }}
            startIcon={<DownloadIcon />}
            onClick={handleRedirectToExport}
          >
            Download Schem in Excel
          </Button>
          <Button
            variant="outlined"
            color="success"
            sx={{ marginTop: 2, marginLeft: 1 }}
            startIcon={<DownloadIcon />}
            onClick={handleDownloadTable}
          >
            Download Data
          </Button>
        </Box>
      </Box>

      <Paper sx={{ padding: 2, marginBottom: 2, marginTop: 2 }}>
        <Autocomplete
          options={schemes}
          getOptionLabel={(option) => option.label}
          onChange={(event, newValue) => setSelectedScheme(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Scheme"
              placeholder="Choose a scheme..."
              variant="outlined"
              fullWidth
            />
          )}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginRight: 1 }}
            onClick={handleSubmit}
            disabled={!selectedScheme}
          >
            Submit
          </Button>
        </Box>
      </Paper>

      {mechanicData.length > 0 && (
      <Paper sx={{ padding: 2 }}>
         <TableContainer sx={{ maxHeight: 400 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#add8e6' }}>
            <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6", }}>Mechanic ID</TableCell>
            <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6", }}>Mechanic Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6", }}>Sl No</TableCell>
            <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6", }}>Points</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mechanicData.map((row, index) => (
            <TableRow key={row.Mechanic_id || index}>
              <TableCell>{row.Mechanic_id}</TableCell>
              <TableCell>{row.Mechanic_Name}</TableCell>
              <TableCell>{row.Serial_No}</TableCell>
              <TableCell>{row.points}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </TableContainer>
    </Paper>
    
      )}
    </Container>
  );
};

export default MechanicReport;
